<template>
  <div class="text-center">
    <v-dialog v-model="mostradoDialogo" width="1200" persistent scrollable>
      <v-card>
        <v-card-title class="py-2 px-0 blue darken-3 white--text">
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <span v-if="inscripcion" class="ml-4 text-h6">
              Subir documentos de
              <strong>
                {{ inscripcion.estudiante.nombres }}
                {{ inscripcion.estudiante.pri_apellido }}
                {{ inscripcion.estudiante.seg_apellido }}
              </strong>
              {{ proposito ? `(${propositosTiposDocumentosPersonaTextos[proposito]})` : '' }}
            </span>

            <v-btn color="white" :disabled="cargandoTodo" icon @click="mostradoDialogo = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="pb-0" :class="{ 'px-0': $vuetify.breakpoint.smAndDown }">
          <template
            v-if="cargandoRequisitosDocumentales || cargandoDocumentacionPorInscripcion || cargandoDocumentosPersona">
            <div class="d-flex justify-center align-center" style="height: 450px">
              <div class="text-center my-5">
                <v-progress-circular indeterminate color="primary" size="64" />

                <p class="mt-3">Cargando requisitos documentales, documentos cargados y documentos existentes...</p>
              </div>
            </div>
          </template>

          <template v-else>
            <div v-if="datosParaSubir.length === 0" class="text-center my-5">
              <p class="red--text">
                No hay requisitos documentales para el tipo de programa
                <strong>{{ programa ? programa.postgrado.categoria.nombre : '' }}</strong>
                de la institución <strong>{{ programa ? programa.universidad.nombre : '' }}</strong
                >.
              </p>

              <router-link v-if="permisosDNA" :to="{ name: 'comisiones-instituciones' }">
                Ir a configuración de instituciones
              </router-link>
            </div>

            <template v-else>
              <!-- STEER VERTICAL -->
              <v-stepper v-model="stepperActivo" class="pb-0" vertical outlined>
                <!-- PASOS -->
                <template v-for="(dato, i) in datosParaSubir">
                  <v-stepper-step
                    :key="`${i}-step`"
                    class="py-3"
                    :class="{ 'px-2': $vuetify.breakpoint.smAndDown }"
                    :complete="stepperActivo > i + 1"
                    :step="i + 1"
                    edit-icon="mdi-file"
                    editable
                    @click="tabActiva = 'tab1'">
                    <div class="d-flex flex-wrap justify-space-between align-center">
                      <div>
                        {{ dato.nombre }}

                        <small v-if="estaCargado(dato.id)" class="green--text text-caption">
                          <v-icon x-small class="mr-1" color="success">mdi-check-circle</v-icon>

                          Documento subido al sistema
                        </small>

                        <small v-if="dato.formValido" class="orange--text text-caption">
                          <v-icon x-small class="mr-1" color="orange">mdi-check-circle</v-icon>

                          Documento listo para subir
                        </small>

                        <small v-if="!estaCargado(dato.id) && !dato.formValido" class="gray--text text-caption">
                          <v-icon x-small class="mr-1" color="gray">mdi-alert-circle</v-icon>

                          Complete los datos requeridos
                        </small>
                      </div>

                      <v-btn
                        v-if="
                          !!dato.uriPlantillaDescargable &&
                          (!estaCargado(dato.id) ||
                            (estaCargado(dato.id) &&
                              obtenerDatoCargado(dato.id).documentoPersona.estadoRevision !== estadoAprobado))
                        "
                        color="secondary"
                        title="Descargar Plantilla"
                        small
                        @click="descargarPlantilla(dato.uriPlantillaDescargable)">
                        <v-icon>mdi-download</v-icon>

                        Descargar Plantilla
                      </v-btn>
                    </div>
                  </v-stepper-step>

                  <!-- CONTENIDO DE CADA PASO -->
                  <v-stepper-content
                    :key="`${i}-content`"
                    class="mb-0 py-2"
                    :class="{ 'ml-2': $vuetify.breakpoint.smAndDown }"
                    :step="i + 1">
                    <p v-if="!estaCargado(dato.id) && !permisosOperativos" class="red--text text-center">
                      No tiene permisos para subir o vincular documentos.
                    </p>

                    <v-tabs
                      v-if="estaCargado(dato.id) || (!estaCargado(dato.id) && permisosOperativos)"
                      v-model="tabActiva"
                      grow>
                      <v-tab v-if="estaCargado(dato.id)" tab-value="tab1"> Ver Datos Cargados </v-tab>
                      <v-tab v-if="!estaCargado(dato.id) && permisosOperativos" tab-value="tab1">
                        Subir Nueva Documentación
                      </v-tab>
                      <v-tab
                        v-if="permisosOperativos"
                        tab-value="tab2"
                        :disabled="estaCargado(dato.id) || documentosPersonaPorTipoDocumento(dato.id).length === 0">
                        Vincular Documentación Existente
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tabActiva">
                      <v-tab-item
                        v-if="estaCargado(dato.id) || (!estaCargado(dato.id) && permisosOperativos)"
                        value="tab1">
                        <v-card flat>
                          <v-card-text class="px-0 py-2">
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <!-- Mostrar datos ya cargados -->
                                <div v-if="estaCargado(dato.id)" class="mt-3">
                                  <v-card outlined>
                                    <v-card-text class="pa-0">
                                      <v-list dense>
                                        <v-list-item
                                          v-if="
                                            obtenerDatoCargado(dato.id).documentoPersona.tipoDocumentoPersona
                                              .aplicaFechaVencimiento
                                          "
                                          dense>
                                          <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold">
                                              Fecha de Vencimiento
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                              {{
                                                obtenerDatoCargado(dato.id).documentoPersona.esIndefinido
                                                  ? 'Indefinido'
                                                  : obtenerDatoCargado(dato.id).documentoPersona.fechaVencimiento
                                              }}
                                            </v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item dense>
                                          <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold"> Subido Por </v-list-item-title>

                                            <v-list-item-subtitle>
                                              {{ obtenerDatoCargado(dato.id).documentoPersona.subidoPor }}
                                            </v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item dense>
                                          <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold"> Subido En </v-list-item-title>

                                            <v-list-item-subtitle>
                                              {{
                                                new Date(
                                                  obtenerDatoCargado(dato.id).documentoPersona.creadoEn,
                                                ).toLocaleString('es-BO', {
                                                  year: 'numeric',
                                                  month: '2-digit',
                                                  day: '2-digit',
                                                  hour: '2-digit',
                                                  minute: '2-digit',
                                                  second: '2-digit',
                                                })
                                              }}
                                            </v-list-item-subtitle>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card-text>
                                  </v-card>

                                  <v-simple-table class="mt-2" dense>
                                    <thead>
                                      <tr>
                                        <th colspan="2" class="font-weight-bold text-center">
                                          Datos adicionales del documento
                                        </th>
                                      </tr>

                                      <tr>
                                        <th class="font-weight-bold">Nombre</th>
                                        <th class="font-weight-bold">Valor</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr v-for="(campoCargado, k) in obtenerDatosCargados(dato.id)" :key="k">
                                        <td class="font-weight-bold">{{ campoCargado.nombre }}</td>
                                        <td>{{ campoCargado.valor }}</td>
                                      </tr>

                                      <tr>
                                        <td
                                          v-if="obtenerDatosCargados(dato.id).length === 0"
                                          class="text-caption"
                                          colspan="2">
                                          No hay datos adicionales cargados para este documento.
                                        </td>
                                      </tr>
                                    </tbody>
                                  </v-simple-table>

                                  <v-btn
                                    v-if="
                                      obtenerDatoCargado(dato.id).documentoPersona.estadoRevision === estadoPendiente &&
                                      ((permisosDNA &&
                                        obtenerDatoCargado(dato.id).documentoPersona.tipoDocumentoPersona.proposito !==
                                          propositosTiposDocumentosPersona.EMITIDO) ||
                                        (permisosResponsablesTitulaciones &&
                                          obtenerDatoCargado(dato.id).documentoPersona.tipoDocumentoPersona
                                            .proposito === propositosTiposDocumentosPersona.EMITIDO)) &&
                                      dato.requiereValidacion
                                    "
                                    class="mt-4"
                                    color="orange"
                                    type="button"
                                    :title="`Validar documento ${dato.nombre}`"
                                    block
                                    elevation="2"
                                    outlined
                                    @click="
                                      mostrarDialogoFormularioRevision(obtenerDatoCargado(dato.id).documentoPersona.id)
                                    ">
                                    <v-icon left>mdi-check-circle</v-icon>

                                    Validar documento
                                  </v-btn>

                                  <DocumentoEstado
                                    v-else-if="dato.requiereValidacion"
                                    :documento-persona="obtenerDatoCargado(dato.id).documentoPersona" />
                                </div>

                                <template v-if="!estaCargado(dato.id)">
                                  <v-form
                                    :ref="`formDocumento-${dato.id}`"
                                    v-model="dato.formValido"
                                    :disabled="subiendoArchivos">
                                    <div class="d-flex flex-wrap justify-space-between align-start">
                                      <!-- Input de archivo -->
                                      <v-file-input
                                        name="archivo"
                                        :accept="aceptarTiposArchivos(dato.formatoPermitido)"
                                        label="Seleccionar archivo"
                                        placeholder="Seleccione el archivo para subir"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-paperclip"
                                        :rules="[
                                          (v) => !!v || 'Archivo requerido',
                                          (v) =>
                                            !v ||
                                            v.size <= 5 * 1024 * 1024 ||
                                            'El archivo debe ser como máximo de 5 MB',
                                        ]"
                                        :truncate-length="30"
                                        :disabled="estaCargado(dato.id)"
                                        :value="dato.archivo"
                                        required
                                        dense
                                        clearable
                                        outlined
                                        show-size
                                        @change="onChangeArchivo($event, dato)" />

                                      <v-btn
                                        v-if="
                                          soportaGetUserMedia &&
                                          dato.formatoPermitido !== formatoPermitidoPdf &&
                                          dato.permiteCapturaCamara
                                        "
                                        :class="{
                                          'ml-2': !$vuetify.breakpoint.smAndDown,
                                          'mb-7': $vuetify.breakpoint.smAndDown,
                                        }"
                                        outlined
                                        :block="$vuetify.breakpoint.smAndDown"
                                        color="primary"
                                        :disabled="estaCargado(dato.id) || subiendoArchivos"
                                        @click="abrirCamara(dato)">
                                        <v-icon v-if="!$vuetify.breakpoint.smAndDown">mdi-camera</v-icon>

                                        <template v-else>
                                          <v-icon left>mdi-camera</v-icon>

                                          Capturar con cámara
                                        </template>
                                      </v-btn>
                                    </div>

                                    <div v-if="dato.aplicaFechaVencimiento" class="d-flex flex-wrap align-start">
                                      <v-menu
                                        v-model="dato.menuFechaVencimiento"
                                        transition="scale-transition"
                                        min-width="290px"
                                        :close-on-content-click="false"
                                        offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="dato.fechaVencimiento"
                                            prepend-inner-icon="mdi-calendar"
                                            label="Fecha de Vencimiento"
                                            placeholder="Fecha de Vencimiento"
                                            :rules="[
                                              (v) => !!v || dato.esIndefinido || 'La fecha de vencimiento es requerida',
                                            ]"
                                            :disabled="dato.esIndefinido"
                                            dense
                                            outlined
                                            readonly></v-text-field>
                                        </template>

                                        <v-date-picker
                                          v-model="dato.fechaVencimiento"
                                          :disabled="dato.esIndefinido"
                                          :min="
                                            new Date()
                                              .toLocaleString('es-BO', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                              })
                                              .split('/')
                                              .reverse()
                                              .join('-')
                                          "
                                          @input="dato.menuFechaVencimiento = false"></v-date-picker>
                                      </v-menu>

                                      <v-checkbox
                                        v-model="dato.esIndefinido"
                                        class="mt-1 ml-sm-3"
                                        label="Indefinido"
                                        @change="
                                          () => {
                                            dato.fechaVencimiento = null;
                                          }
                                        "></v-checkbox>
                                    </div>

                                    <!-- Campos de datos dinámicos -->

                                    <div
                                      v-if="dato.plantillaDatos && dato.plantillaDatos.length > 0"
                                      class="font-weight-bold">
                                      Datos Adicionales
                                    </div>

                                    <v-divider class="mt-0"></v-divider>

                                    <div v-for="(campo, j) in dato.plantillaDatos" :key="j" class="mt-3">
                                      <!-- Campo de fecha -->
                                      <v-menu
                                        v-if="campo.tipo === tiposCampos.FECHA"
                                        v-model="menusFechas[campo.id]"
                                        transition="scale-transition"
                                        min-width="290px"
                                        :close-on-content-click="false"
                                        offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-text-field
                                            v-bind="attrs"
                                            v-on="on"
                                            v-model="campo.valor"
                                            prepend-inner-icon="mdi-calendar"
                                            :name="campo.id"
                                            :label="campo.nombre"
                                            :placeholder="campo.nombre"
                                            :rules="[(v) => !!v || `${campo.nombre} requerido`]"
                                            dense
                                            outlined
                                            readonly
                                            :disabled="estaCargado(dato.id)"></v-text-field>
                                        </template>

                                        <v-date-picker
                                          v-model="campo.valor"
                                          :disabled="estaCargado(dato.id)"
                                          @input="menusFechas[campo.id] = false"></v-date-picker>
                                      </v-menu>

                                      <!-- Campo de número -->
                                      <v-text-field
                                        v-else-if="campo.tipo === tiposCampos.NUMERO"
                                        v-model.number="campo.valor"
                                        type="number"
                                        :name="campo.id"
                                        :label="campo.nombre"
                                        :placeholder="campo.nombre"
                                        :rules="[
                                          (v) =>
                                            (v !== '' && v !== null && v !== undefined) || `${campo.nombre} requerido`,
                                        ]"
                                        :disabled="estaCargado(dato.id)"
                                        dense
                                        outlined></v-text-field>

                                      <!-- Campo de texto largo -->
                                      <v-textarea
                                        v-else-if="campo.tipo === tiposCampos.TEXTO"
                                        v-model="campo.valor"
                                        rows="3"
                                        :name="campo.id"
                                        :label="campo.nombre"
                                        :placeholder="campo.nombre"
                                        :rules="[(v) => !!v || `${campo.nombre} requerido`]"
                                        :disabled="estaCargado(dato.id)"
                                        dense
                                        outlined
                                        @input="normalizarTexto(campo)"></v-textarea>

                                      <!-- Campo de opción múltiple -->
                                      <v-select
                                        v-else-if="campo.tipo === tiposCampos.SELECCION_MULTIPLE"
                                        v-model="campo.valor"
                                        :items="campo.opciones || []"
                                        :name="campo.id"
                                        :label="campo.nombre"
                                        :placeholder="`Seleccione una o más opciones para ${campo.nombre}`"
                                        :rules="[(v) => (v && v.length > 0) || `${campo.nombre} requerido`]"
                                        :disabled="estaCargado(dato.id)"
                                        dense
                                        outlined></v-select>
                                    </div>

                                    <v-btn
                                      class="mt-4"
                                      color="primary"
                                      type="button"
                                      :title="`Subir documento ${dato.nombre}`"
                                      block
                                      elevation="2"
                                      outlined
                                      :disabled="dato.subiendo"
                                      :loading="dato.subiendo"
                                      @click="validarIndividual(dato.id)">
                                      <v-icon left>mdi-upload</v-icon>

                                      Subir documento
                                    </v-btn>
                                  </v-form>
                                </template>
                              </v-col>

                              <v-col cols="12" md="6">
                                <!-- Vista previa -->
                                <div v-if="dato.previewUrl">
                                  <ImagenPreview
                                    v-if="dato.archivo && dato.archivo.type.startsWith('image/')"
                                    :src="dato.previewUrl"
                                    :nombre-archivo="nombreArchivo(dato.nombre)"
                                    :alt="`Preview de ${dato.nombre}`" />
                                  <PdfPreview
                                    v-else-if="dato.archivo && dato.archivo.type === 'application/pdf'"
                                    :src="dato.previewUrl"
                                    :nombre-archivo="nombreArchivo(dato.nombre)" />
                                </div>

                                <!-- Vista del documento ya cargado -->
                                <div
                                  v-if="estaCargado(dato.id) && obtenerArchivoPreviewUrl(dato.id)"
                                  style="border: 1px solid #ccc; border-radius: 4px; padding: 4px">
                                  <ImagenPreview
                                    v-if="obtenerTipoArchivo(dato.id) === 'image'"
                                    :src="obtenerArchivoPreviewUrl(dato.id)"
                                    :nombre-archivo="nombreArchivo(dato.nombre)"
                                    :alt="`Preview de ${dato.nombre}`" />
                                  <PdfPreview
                                    v-else-if="obtenerTipoArchivo(dato.id) === 'pdf'"
                                    :src="obtenerArchivoPreviewUrl(dato.id)"
                                    :nombre-archivo="nombreArchivo(dato.nombre)" />
                                </div>

                                <v-alert
                                  v-if="estaCargado(dato.id) && !obtenerArchivoPreviewUrl(dato.id)"
                                  class="mt-5"
                                  border="left"
                                  colored-border
                                  type="warning"
                                  text>
                                  No hay archivo disponible para este registro. Es posible que el archivo haya sido
                                  eliminado o que no se haya subido correctamente.
                                </v-alert>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item v-if="permisosOperativos" value="tab2">
                        <v-card flat>
                          <v-card-text class="px-0 py-2">
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <DocumentoExistente
                                  :documentos="documentosPersonaPorTipoDocumento(dato.id)"
                                  :documento-seleccionado="documentoPersonaSeleccionado"
                                  @documento-seleccionado="documentoPersonaSeleccionado = $event" />

                                <v-btn
                                  v-if="!estaCargado(dato.id)"
                                  class="mt-4"
                                  color="primary"
                                  type="button"
                                  :title="`Vincular documento ${dato.nombre}`"
                                  block
                                  elevation="2"
                                  outlined
                                  :disabled="
                                    !documentoPersonaSeleccionado ||
                                    documentoPersonaSeleccionado.tipoDocumentoPersonaId !== dato.id ||
                                    dato.vinculando
                                  "
                                  :loading="dato.vinculando"
                                  @click="mostrarDialogoConfirmacionVinculacionDocumento">
                                  <v-icon left>mdi-link</v-icon>

                                  Vincular documento
                                </v-btn>
                              </v-col>

                              <v-col cols="12" md="6">
                                <template
                                  v-if="
                                    !documentoPersonaSeleccionado ||
                                    documentoPersonaSeleccionado.tipoDocumentoPersonaId !== dato.id
                                  ">
                                  <p class="text-center my-5">
                                    Seleccione un documento existente para ver su vista previa.
                                  </p>
                                </template>

                                <template v-else>
                                  <ImagenPreview
                                    v-if="documentoPersonaSeleccionado.archivo.mimetype.startsWith('image/')"
                                    :src="
                                      base64AUrl(
                                        documentoPersonaSeleccionado.archivo.file64,
                                        documentoPersonaSeleccionado.archivo.mimetype,
                                      )
                                    "
                                    :nombre-archivo="
                                      nombreArchivo(documentoPersonaSeleccionado.tipoDocumentoPersona.nombre)
                                    "
                                    :alt="`Preview de ${documentoPersonaSeleccionado.tipoDocumentoPersona.nombre}`" />
                                  <PdfPreview
                                    v-else-if="documentoPersonaSeleccionado.archivo.mimetype === 'application/pdf'"
                                    :src="
                                      base64AUrl(
                                        documentoPersonaSeleccionado.archivo.file64,
                                        documentoPersonaSeleccionado.archivo.mimetype,
                                      )
                                    "
                                    :nombre-archivo="
                                      nombreArchivo(documentoPersonaSeleccionado.tipoDocumentoPersona.nombre)
                                    " />
                                </template>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-stepper-content>
                </template>
              </v-stepper>
            </template>
          </template>
        </v-card-text>

        <v-divider class="my-0"></v-divider>

        <v-card-actions class="d-flex flex-wrap justify-end align-center">
          <v-btn color="error" class="ma-1" :disabled="cargandoTodo" outlined @click="mostradoDialogo = false">
            <v-icon left>mdi-close</v-icon>

            Cerrar
          </v-btn>

          <v-btn
            v-if="datosParaSubir.length > 0 && !todosCargados() && permisosOperativos"
            class="ma-1"
            color="success"
            :loading="cargandoTodo"
            :disabled="cargandoTodo || todosCargados()"
            outlined
            @click="validar">
            <v-icon left>mdi-upload</v-icon>

            {{ textoBoton }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CamaraCaptura v-model="mostrarCamara" @archivo-capturado="onArchivoCapturado" />

    <notifications group="notifications" position="top right" />

    <FormularioRevision ref="formularioRevision" @documento-revisado="obtenerDocumentacionPorInscripcion" />

    <ConfirmacionAccion
      v-model="mostradoDialogoConfirmacion"
      v-bind="confirmacion"
      @aceptar="() => confirmacion.aceptar()" />
  </div>
</template>

<script>
import inscripcionesDocumentosPersonasService from '../comisiones/services/inscripciones-documentos-personas.service';
import requisitosDocumentalesService from '../comisiones/services/requisitos-documentales.service';
import { concatenar } from '../pagos/utils/funciones';
import ImagenPreview from './components/ImagenPreview.vue';
import PdfPreview from './components/PdfPreview.vue';
import documentosPersonasService from '../comisiones/services/documentos-personas.service';
import DocumentoExistente from './components/DocumentoExistente.vue';
import DocumentoEstado from './components/DocumentoEstado.vue';
import FormularioRevision from './components/FormularioRevision.vue';
import ConfirmacionAccion from './components/ConfirmacionAccion.vue';
import CamaraCaptura from './components/CamaraCaptura.vue';
import { mapGetters } from 'vuex';
import {
  ESTADOS_TIPO_DOCUMENTO_PERSONA,
  formatoImagen,
  formatoPdf,
  FORMATOS_PERMITIDOS,
  PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA,
  PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS,
  TIPOS_CAMPOS,
} from '../comisiones/utils/constantes';
import plantillasService from '../comisiones/services/plantillas.service';

export default {
  name: 'SubirDocumentacion',
  components: {
    ImagenPreview,
    PdfPreview,
    DocumentoExistente,
    DocumentoEstado,
    FormularioRevision,
    ConfirmacionAccion,
    CamaraCaptura,
  },
  data() {
    return {
      mostradoDialogo: false,
      verDocumentosDialog: false,
      cargandoRequisitosDocumentales: false,
      requisitosDocumentales: [],
      cargandoDocumentacionPorInscripcion: false,
      documentosPersona: [],
      cargandoDocumentosPersona: false,
      documentoPersonaSeleccionado: null,
      estadoPendiente: ESTADOS_TIPO_DOCUMENTO_PERSONA.PENDIENTE,
      estadoAprobado: ESTADOS_TIPO_DOCUMENTO_PERSONA.APROBADO,
      datosRevision: {
        estadoRevision: null,
        observaciones: null,
      },
      menusFechas: {},
      subiendoArchivos: false,
      index: 0,
      inscripcion: null,
      programa: null,
      datosParaSubir: [],
      datosCargados: [],
      stepperActivo: 1,
      tabActiva: 'tab1',
      mostradoDialogoConfirmacion: false,
      confirmacion: {
        titulo: '',
        mensaje: '',
        textoAceptar: '',
        textoCancelar: '',
        realizandoAccion: false,
        aceptar: () => {
          window.console.log('Implementar acción de confirmación');
        },
      },
      proposito: null,
      mostrarCamara: false,
      datoConCamara: null,
      tiposCampos: TIPOS_CAMPOS,
      propositosTiposDocumentosPersona: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA,
      propositosTiposDocumentosPersonaTextos: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_TEXTOS,
      formatoPermitidoPdf: FORMATOS_PERMITIDOS.PDF,
    };
  },
  computed: {
    cargandoTodo() {
      return (
        this.cargandoRequisitosDocumentales ||
        this.cargandoDocumentacionPorInscripcion ||
        this.subiendoArchivos ||
        this.cargandoDocumentosPersona
      );
    },
    textoBoton() {
      return this.datosCargados.length > 0 && this.datosCargados.length < this.datosParaSubir.length
        ? 'Subir documentos faltantes'
        : 'Subir todos los documentos';
    },
    nombreArchivo() {
      return (nombreDocumento) => {
        if (this.inscripcion) {
          const estudiante = this.inscripcion.estudiante;
          const nombreEstudiante = concatenar(estudiante.nombres, estudiante.pri_apellido, estudiante.seg_apellido);

          return `${nombreDocumento} - ${nombreEstudiante}`;
        }

        return nombreDocumento;
      };
    },
    documentosPersonaPorTipoDocumento() {
      return (tipoDocumentoId) => {
        return this.documentosPersona.filter((doc) => doc.tipoDocumentoPersonaId === tipoDocumentoId);
      };
    },
    ...mapGetters({
      permisosResponsablesAdmisiones: 'comision/permisosResponsablesAdmisiones',
      permisosDNA: 'comision/permisosDNA',
      permisosResponsablesTitulaciones: 'comision/permisosResponsablesTitulaciones',
    }),
    permisosOperativos() {
      return this.proposito === PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.INSCRIPCION
        ? this.permisosResponsablesAdmisiones
        : this.proposito === PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.TITULACION
        ? this.permisosResponsablesTitulaciones
        : this.proposito === PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.EMITIDO
        ? this.permisosDNA
        : this.proposito === PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA.RECEPCION
        ? this.permisosResponsablesAdmisiones || this.permisosResponsablesTitulaciones || this.permisosDNA
        : false;
    },
    soportaGetUserMedia() {
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
    },
  },
  watch: {
    mostradoDialogo(nuevoValor) {
      if (!nuevoValor) {
        this._limpiarEstadoCamara();
      }
    },
  },
  mounted() {
    window.addEventListener('pagehide', this._guardarEstadoCamara);
    document.addEventListener('visibilitychange', this._onVisibilityChange);
    this._restaurarEstadoCamara();
  },
  beforeDestroy() {
    window.removeEventListener('pagehide', this._guardarEstadoCamara);
    document.removeEventListener('visibilitychange', this._onVisibilityChange);
  },
  methods: {
    async obtenerRequisitosDocumentales() {
      if (!this.programa || !this.inscripcion) {
        return;
      }

      this.cargandoRequisitosDocumentales = true;
      this.requisitosDocumentales = [];

      try {
        const params = {
          institucionId: this.programa.universidad.id,
          categoriaId: this.programa.postgrado.categoria.id,
          proposito: this.proposito,
        };
        const response = await requisitosDocumentalesService.findAll({ params });
        const data = response.data;

        this.requisitosDocumentales = data.datos || [];
        const tiposDocumentos = this.requisitosDocumentales.map((rd) => rd.tipoDocumentoPersona);
        this.datosParaSubir = tiposDocumentos.map((td) => ({
          ...td,
          formValido: false,
          subiendo: false,
          vinculando: false,
          previewUrl: null,
          archivo: null,
          menuFechaVencimiento: false,
          fechaVencimiento: null,
          esIndefinido: td.aplicaFechaVencimiento ? false : null,
        }));
      } catch (error) {
        this.requisitosDocumentales = [];

        window.console.error('Error al cargar requisitos documentales:', error);
      } finally {
        this.cargandoRequisitosDocumentales = false;
      }
    },
    async obtenerDocumentacionPorInscripcion() {
      if (!this.inscripcion) {
        return;
      }

      this.cargandoDocumentacionPorInscripcion = true;
      this.datosCargados = [];

      try {
        const response = await inscripcionesDocumentosPersonasService.findByInscripcion(this.inscripcion.id);
        const data = response.data;

        this.datosCargados = data.datos || [];
        this.precargarDatos();
      } catch (error) {
        this.datosCargados = [];

        window.console.error('Error al cargar documentos cargados:', error);
      } finally {
        this.cargandoDocumentacionPorInscripcion = false;
      }
    },

    async abrir(inscripcion, programa, proposito) {
      this._limpiarEstadoCamara();
      if (!Object.values(PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA).includes(proposito)) {
        return;
      }

      this.inscripcion = inscripcion;
      this.programa = programa;
      this.datosParaSubir = [];
      this.datosCargados = [];
      this.index += 1;
      this.mostradoDialogo = true;
      this.stepperActivo = 1;
      this.proposito = proposito;

      await Promise.all([this.obtenerRequisitosDocumentales(), this.obtenerDocumentacionPorInscripcion()]).then(() => {
        this.obtenerDocumentosPersona();
      });
    },

    async obtenerDocumentosPersona() {
      if (!this.inscripcion || !this.requisitosDocumentales || this.requisitosDocumentales.length === 0) {
        return;
      }

      let tiposDocumentosPersonasIds = this.requisitosDocumentales.map((rd) => rd.tipoDocumentoPersona.id);
      tiposDocumentosPersonasIds = tiposDocumentosPersonasIds.filter((id) => {
        return !this.estaCargado(id);
      });

      if (tiposDocumentosPersonasIds.length === 0) {
        return;
      }

      this.cargandoDocumentosPersona = true;
      this.documentosPersona = [];

      try {
        const params = {
          tiposDocumentosPersonasIds: tiposDocumentosPersonasIds.join(','),
          esReutilizable: true,
        };
        const response = await documentosPersonasService.findByPersona(this.inscripcion.estudiante.id, { params });
        const data = response.data;

        this.documentosPersona = data.datos || [];
      } catch (error) {
        this.documentosPersona = [];

        window.console.error('Error al cargar documentos cargados:', error);
      } finally {
        this.cargandoDocumentosPersona = false;
      }
    },

    async vincularDocumentoPersonaAInscripcion() {
      if (
        !this.inscripcion ||
        !this.documentoPersonaSeleccionado ||
        this.documentoPersonaSeleccionado.tipoDocumentoPersonaId === null
      ) {
        return;
      }

      const dato = this.datosParaSubir.find((d) => d.id === this.documentoPersonaSeleccionado.tipoDocumentoPersonaId);

      if (!dato) {
        return;
      }

      dato.vinculando = true;

      try {
        const response = await inscripcionesDocumentosPersonasService.vincularDocumentoPersonaAInscripcion({
          inscripcionId: this.inscripcion.id,
          documentoPersonaId: this.documentoPersonaSeleccionado.id,
        });
        const data = response.data;
        const mensaje = data.mensaje || 'Documento vinculado correctamente';

        this.documentoPersonaSeleccionado = null;
        this.tabActiva = 'tab1';
        this.$notify({
          group: 'notifications',
          title: 'Documento vinculado',
          text: mensaje,
          type: 'success',
        });

        await Promise.all([this.obtenerRequisitosDocumentales(), this.obtenerDocumentacionPorInscripcion()]).then(
          () => {
            this.obtenerDocumentosPersona();
          },
        );
      } catch (err) {
        const mensajeError =
          err.response && err.response.data && err.response.data.mensaje
            ? err.response.data.mensaje
            : 'Error al vincular el documento';

        this.$notify({
          group: 'notifications',
          title: 'Error al vincular documento',
          text: mensajeError,
          type: 'error',
        });
      } finally {
        dato.vinculando = false;
      }
    },

    estaCargado(tipoDocumentoId) {
      return this.datosCargados.some(
        (datoCargado) => datoCargado.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId,
      );
    },

    obtenerDatoCargado(tipoDocumentoId) {
      return this.datosCargados.find(
        (datoCargado) => datoCargado.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId,
      );
    },

    obtenerDatosCargados(tipoDocumentoId) {
      const datoCargado = this.obtenerDatoCargado(tipoDocumentoId);

      if (!datoCargado) {
        return [];
      }

      return datoCargado.documentoPersona.datos;
    },

    base64AUrl(file64, mimetype) {
      const byteCharacters = atob(file64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimetype });

      return URL.createObjectURL(blob);
    },

    obtenerArchivoPreviewUrl(tipoDocumentoId) {
      const datoCargado = this.datosCargados.find(
        (datoCargado) => datoCargado.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId,
      );

      if (datoCargado && datoCargado.documentoPersona.archivo) {
        const archivo = datoCargado.documentoPersona.archivo;

        return this.base64AUrl(archivo.file64, archivo.mimetype);
      }

      return null;
    },

    obtenerTipoArchivo(tipoDocumentoId) {
      const datoCargado = this.datosCargados.find(
        (datoCargado) => datoCargado.documentoPersona.tipoDocumentoPersonaId === tipoDocumentoId,
      );

      if (datoCargado && datoCargado.documentoPersona.archivo) {
        const mimeType = datoCargado.documentoPersona.archivo.mimetype;

        if (mimeType.startsWith('image/')) {
          return 'image';
        }

        if (mimeType === 'application/pdf') {
          return 'pdf';
        }
      }

      return null;
    },

    todosCargados() {
      return this.datosParaSubir.length > 0 && this.datosParaSubir.every((dato) => this.estaCargado(dato.id));
    },

    descargarArchivo(archivo, nombre) {
      const nombreCompletoEstudiante = `${this.inscripcion.estudiante.nombres} ${this.inscripcion.estudiante.pri_apellido} ${this.inscripcion.estudiante.seg_apellido}`;
      const nombreArchivo = `${nombre} ${nombreCompletoEstudiante}`;
      const url = this.base64AUrl(archivo.file64, archivo.mimetype);
      const link = document.createElement('a');

      link.href = url;
      link.download = nombreArchivo || 'documento';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    },

    async onChangeArchivo(archivo, dato) {
      dato.archivo = archivo;

      if (archivo) {
        dato.previewUrl = URL.createObjectURL(archivo);
      } else {
        dato.previewUrl = null;
      }
    },

    precargarDatos() {
      this.datosParaSubir.forEach((dato) => {
        const datoCargado = this.datosCargados.find(
          (datoCargado) => datoCargado.documentoPersona.tipoDocumentoPersonaId === dato.id,
        );

        if (datoCargado) {
          dato.plantillaDatos.forEach((campo) => {
            const datoCargadoSeleccionado = datoCargado.documentoPersona.datos.find((dato) => dato.id === campo.id);

            if (datoCargadoSeleccionado) {
              campo.valor = datoCargadoSeleccionado.valor;
            }
          });
        }
      });
    },

    archivoABase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = (error) => reject(error);
      });
    },

    mostrarDialogoConfirmacionSubidaDocumentos() {
      this.confirmacion.titulo = 'Confirmar subida de documentos';
      this.confirmacion.mensaje = '¿Está seguro que desea subir los documentos seleccionados?';
      this.confirmacion.textoAceptar = 'Sí, subir';
      this.confirmacion.textoCancelar = 'Cancelar';
      this.confirmacion.aceptar = () => {
        this.subirDocumentos();
      };
      this.mostradoDialogoConfirmacion = true;
    },

    async validar() {
      for (let i = 0; i < this.datosParaSubir.length; i++) {
        const dato = this.datosParaSubir[i];
        const refForm = this.$refs[`formDocumento-${dato.id}`];

        if (!refForm || !refForm[0]) {
          continue;
        }

        if (!refForm[0].validate()) {
          this.$notify({
            group: 'notifications',
            title: 'Error al subir documentos',
            text: `El formulario para el documento: ${dato.nombre} no es válido.`,
            type: 'error',
          });
          this.stepperActivo = i + 1;

          return;
        }
      }

      this.mostrarDialogoConfirmacionSubidaDocumentos();
    },
    async subirDocumentos() {
      const documentosPersonas = [];

      for (let i = 0; i < this.datosParaSubir.length; i++) {
        const dato = this.datosParaSubir[i];

        const refForm = this.$refs[`formDocumento-${dato.id}`];

        if (!refForm || !refForm[0]) {
          continue;
        }

        const archivoBase64 = await this.archivoABase64(dato.archivo);

        documentosPersonas.push({
          tipoDocumentoPersonaId: dato.id,
          datos: dato.plantillaDatos,
          archivoBase64,
          fechaVencimiento: dato.esIndefinido ? null : dato.fechaVencimiento,
          esIndefinido: dato.esIndefinido,
        });
      }

      if (!this.inscripcion) {
        return;
      }

      this.subiendoArchivos = true;
      this.confirmacion.realizandoAccion = true;

      try {
        const response = await inscripcionesDocumentosPersonasService.createMany(this.inscripcion.id, {
          documentosPersonas,
        });
        const data = response.data;
        const mensaje = data.mensaje || 'Documentos subidos correctamente';

        this.$notify({
          group: 'notifications',
          title: 'Documentos subidos',
          text: mensaje,
          type: 'success',
        });
        this.mostradoDialogoConfirmacion = false;

        await Promise.all([this.obtenerRequisitosDocumentales(), this.obtenerDocumentacionPorInscripcion()]);
      } catch (err) {
        const response = err?.response;
        const data = response?.data;
        const errores = data?.errores || 'Error al enviar los documentos';

        window.console.error('Error al subir documentos:', err);

        const mensajesErrores = Object.values(errores).flat().join(', ');

        this.$notify({
          group: 'notifications',
          title: 'Error al subir documentos',
          text: mensajesErrores,
          type: 'error',
        });
      } finally {
        this.subiendoArchivos = false;
        this.confirmacion.realizandoAccion = false;
      }
    },

    async validarIndividual(tipoDocumentoId) {
      const dato = this.datosParaSubir.find((d) => d.id === tipoDocumentoId);
      const refForm = this.$refs[`formDocumento-${dato.id}`];

      if (!refForm) {
        return;
      }

      if (!refForm[0].validate()) {
        this.$notify({
          group: 'notifications',
          title: 'Error al subir documento',
          text: `El formulario para el documento: ${dato.nombre} no es válido.`,
          type: 'error',
        });

        return;
      }

      this.mostrarDialogoConfirmacionSubidaDocumento(tipoDocumentoId);
    },

    async subirDocumento(tipoDocumentoId) {
      const dato = this.datosParaSubir.find((d) => d.id === tipoDocumentoId);
      const archivoBase64 = await this.archivoABase64(dato.archivo);
      const documentoPersona = {
        tipoDocumentoPersonaId: dato.id,
        datos: dato.plantillaDatos,
        archivoBase64,
        fechaVencimiento: dato.esIndefinido ? null : dato.fechaVencimiento,
        esIndefinido: dato.esIndefinido,
      };

      if (!this.inscripcion) {
        return;
      }

      dato.subiendo = true;
      this.confirmacion.realizandoAccion = true;

      try {
        const response = await inscripcionesDocumentosPersonasService.create(this.inscripcion.id, { documentoPersona });
        const data = response.data;
        const mensaje = data.mensaje || 'Documento subido correctamente';

        this.$notify({
          group: 'notifications',
          title: 'Documento subido',
          text: mensaje,
          type: 'success',
        });
        this.mostradoDialogoConfirmacion = false;

        await Promise.all([this.obtenerRequisitosDocumentales(), this.obtenerDocumentacionPorInscripcion()]);
      } catch (err) {
        const response = err?.response;
        const data = response?.data;
        const errores = data?.errores || 'Error al enviar el documento';

        window.console.error('Error al subir documento:', err);

        const mensajesErrores = Object.values(errores).flat().join(', ');

        this.$notify({
          group: 'notifications',
          title: 'Error al subir documento',
          text: mensajesErrores,
          type: 'error',
        });
      } finally {
        dato.subiendo = false;
        this.confirmacion.realizandoAccion = false;
      }
    },

    mostrarDialogoFormularioRevision(documentoPersonaId) {
      if (!documentoPersonaId) {
        return;
      }

      this.$refs.formularioRevision.abrir(documentoPersonaId);
    },

    mostrarDialogoConfirmacionSubidaDocumento(tipoDocumentoId) {
      const dato = this.datosParaSubir.find((d) => d.id === tipoDocumentoId);

      if (!dato) {
        return;
      }

      this.confirmacion.titulo = 'Confirmar subida de documento';
      this.confirmacion.mensaje = `¿Está seguro que desea subir el documento: ${dato.nombre}?`;
      this.confirmacion.textoAceptar = 'Sí, subir';
      this.confirmacion.textoCancelar = 'Cancelar';
      this.confirmacion.aceptar = () => {
        this.subirDocumento(tipoDocumentoId);
      };
      this.mostradoDialogoConfirmacion = true;
    },

    mostrarDialogoConfirmacionVinculacionDocumento() {
      const dato = this.datosParaSubir.find((d) => d.id === this.documentoPersonaSeleccionado.tipoDocumentoPersonaId);

      if (!dato) {
        return;
      }

      this.confirmacion.titulo = 'Confirmar vinculación de documento';
      this.confirmacion.mensaje = `¿Está seguro que desea vincular el documento: ${dato.nombre}?`;
      this.confirmacion.textoAceptar = 'Sí, vincular';
      this.confirmacion.textoCancelar = 'Cancelar';
      this.confirmacion.realizandoAccion = false;
      this.confirmacion.aceptar = () => {
        this.vincularDocumentoPersonaAInscripcion();
        this.mostradoDialogoConfirmacion = false;
      };
      this.mostradoDialogoConfirmacion = true;
    },

    normalizarTexto(campo) {
      if (campo && campo.valor) {
        let texto = campo.valor.toUpperCase();

        texto = texto
          .normalize('NFD')
          .replace(/([^n\u0303])[\u0300-\u036f]/gi, '$1')
          .normalize('NFC');
        texto = texto.replace(/[^A-ZÑ0-9\s.,;:\-_()[\]]/g, '');

        campo.valor = texto;
      }
    },

    async descargarPlantilla(uriPlantillaDescargable) {
      const inscripcionId = this.inscripcion ? this.inscripcion.id : null;

      if (!uriPlantillaDescargable || !inscripcionId) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'No se pudo descargar la plantilla. Verifique la URI y el ID de inscripción.',
          type: 'error',
        });

        return;
      }

      try {
        const uriConId = uriPlantillaDescargable.replace('{inscripcionId}', inscripcionId);
        const response = await plantillasService.descargarPlantilla(uriConId);
        const data = response.data;
        const datos = data.datos;
        const nombreArchivo = datos.nombreArchivo;
        const base64 = datos.archivoBase64;

        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = nombreArchivo;
        link.click();
        window.URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'La plantilla se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        const response = error?.response;
        const data = response?.data;
        const mensaje = data?.mensaje || 'Error al descargar la plantilla';

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje,
          type: 'error',
        });
      }
    },

    abrirCamara(dato) {
      this.datoConCamara = dato;
      this.mostrarCamara = true;
    },

    onArchivoCapturado(archivo) {
      if (this.datoConCamara) {
        this.onChangeArchivo(archivo, this.datoConCamara);
      }

      this.datoConCamara = null;
    },

    _guardarEstadoCamara() {
      if (!this.mostradoDialogo || !this.inscripcion || !this.programa || !this.proposito) {
        return;
      }

      try {
        const estado = {
          timestamp: Date.now(),
          inscripcion: this.inscripcion,
          programa: this.programa,
          proposito: this.proposito,
          stepperActivo: this.stepperActivo,
          tabActiva: this.tabActiva,
          camposPorDocumento: this.datosParaSubir.map((dato) => ({
            id: dato.id,
            fechaVencimiento: dato.fechaVencimiento,
            esIndefinido: dato.esIndefinido,
            plantillaDatos: (dato.plantillaDatos || []).map((campo) => ({
              id: campo.id,
              valor: campo.valor,
            })),
          })),
        };

        window.sessionStorage.setItem('SUBIR_DOCUMENTACION_STATE', JSON.stringify(estado));
      } catch (e) {
        window.console.warn('No se pudo guardar estado de cámara:', e);
      }
    },

    _limpiarEstadoCamara() {
      window.sessionStorage.removeItem('SUBIR_DOCUMENTACION_STATE');
    },

    _onVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this._guardarEstadoCamara();
      }
    },

    async _restaurarEstadoCamara() {
      const raw = window.sessionStorage.getItem('SUBIR_DOCUMENTACION_STATE');

      this._limpiarEstadoCamara();

      if (!raw) {
        return;
      }

      let estado;

      try {
        estado = JSON.parse(raw);
      } catch (e) {
        return;
      }

      const DIEZ_MINUTOS_MS = 10 * 60 * 1000;

      if (!estado.timestamp || Date.now() - estado.timestamp > DIEZ_MINUTOS_MS) {
        return;
      }

      if (!estado.inscripcion || !estado.programa || !estado.proposito) {
        return;
      }

      await this.abrir(estado.inscripcion, estado.programa, estado.proposito);

      this.$nextTick(() => {
        this.stepperActivo = estado.stepperActivo || 1;
        this.tabActiva = estado.tabActiva || 'tab1';

        (estado.camposPorDocumento || []).forEach((estadoDato) => {
          const dato = this.datosParaSubir.find((d) => d.id === estadoDato.id);

          if (!dato) {
            return;
          }

          this.$set(dato, 'fechaVencimiento', estadoDato.fechaVencimiento);
          this.$set(dato, 'esIndefinido', estadoDato.esIndefinido);

          if (Array.isArray(estadoDato.plantillaDatos) && Array.isArray(dato.plantillaDatos)) {
            estadoDato.plantillaDatos.forEach((estadoCampo) => {
              const campo = dato.plantillaDatos.find((c) => c.id === estadoCampo.id);

              if (campo) {
                this.$set(campo, 'valor', estadoCampo.valor);
              }
            });
          }
        });

        this.$notify({
          group: 'notifications',
          title: 'Formulario restaurado',
          text: 'Se recuperaron los datos del formulario. Si tomó una foto, selecciónela nuevamente si no aparece.',
          type: 'success',
        });
      });
    },
    aceptarTiposArchivos(formatoPermitido) {
      if (formatoPermitido === FORMATOS_PERMITIDOS.IMAGEN) {
        return formatoImagen;
      }

      if (formatoPermitido === FORMATOS_PERMITIDOS.PDF) {
        return formatoPdf;
      }

      return `${formatoImagen},${formatoPdf}`;
    },
  },
};
</script>

<style>
.v-btn.v-date-picker-table__current.v-btn--rounded.v-btn--outlined.theme--light.accent--text {
  border-color: var(--v-primary-base) !important;
  color: var(--v-primary-base) !important;
}

.v-btn.v-btn--active.v-btn--rounded.theme--light.accent {
  background-color: var(--v-primary-base) !important;
  color: white !important;
}
</style>